import React from 'react'
import PersonalInfo from './PersonalInfo'
import AddressHistory from './AddressHistory'
import RightToWork from './RightToWork'
import EmploymentHistory from './EmploymentHistory'
import SupportingInformation from './SupportingInformation'
import Qualifications from './Qualifications'
import DBS from './DBS'
import Driving from './Driving'
import References from './References'
import Submit from './Submit'

const STEP_COMPONENTS = {
  personal: PersonalInfo,
  address: AddressHistory,
  rightToWork: RightToWork,
  employment: EmploymentHistory,
  statement: SupportingInformation,
  qualifications: Qualifications,
  dbs: DBS,
  driving: Driving,
  references: References,
  review: Submit,
}

const TabSelector = ({ selectedTab, formValues, setFormValues }) => {
  const Step = STEP_COMPONENTS[selectedTab] ?? PersonalInfo
  return <Step formValues={formValues} setFormValues={setFormValues} />
}

export default TabSelector
